import { observer } from 'mobx-react';
import { Fragment, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

const ConfirmationModal = ({
  title,
  titleProps,
  headerProps,
  bodyText,
  showButton,
  showAction,
  showModal = true,
  confirmButton,
  confirmAction
}) => {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const hide = () => {
    setShow(false);
  };

  return (
    <Fragment>
      <Button
        {...showButton.props}
        onClick={() => {
          if (showAction) showAction();
          if (showModal) setShow(true);
        }}
      >
        {showButton.children}
      </Button>
      <Modal backdrop='static' show={show} onHide={() => hide()}>
        <Modal.Header {...headerProps} closeButton>
          <Modal.Title {...titleProps}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{bodyText}</p>
          <Button
            {...confirmButton.props}
            onClick={async () => {
              setLoading(true);
              try {
                await confirmAction();
              } catch (err) {
                if (process.env.NODE_ENV === 'development') console.error(err);
              } finally {
                setLoading(false);
                hide();
              }
            }}
          >
            {loading ? (
              <Spinner className='mx-3' animation='border' size='sm' />
            ) : (
              'Confirm'
            )}
          </Button>
          <Button
            className='ml-1'
            variant='outline-secondary'
            disabled={loading}
            onClick={() => {
              hide();
            }}
          >
            Cancel
          </Button>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default observer(ConfirmationModal);

